import { useState } from "react";
import { AxiosRequest } from "_services/api";

export function useBaixaManualTaxa() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [salvando, setSalvando] = useState(false);

  const pagarManual = async (
    idLote: number,
    idProcesso: number,
    dataPagamento: string,
    comprovante: File,
    observacao: string,
    valorPago: number,
  ) => {
    setSalvando(true);
    try {
      const form = new FormData();
      form.append("dataPagamento", dataPagamento);
      form.append("valorPago", String(valorPago));
      form.append("observacao", observacao);
      if (comprovante) form.append("comprovante", comprovante);

      const { data } = await msAw.post(
        `/financeiro/pagamento-taxa/lote/${idLote}/processos/${idProcesso}/baixa-manual`,
        form,
      );
      return data;
    } finally {
      setSalvando(false);
    }
  };

  const cancelar = async (
    idLote: number,
    idProcesso: number,
    observacao: string,
  ) => {
    setSalvando(true);
    try {
      const { data } = await msAw.post(
        `/financeiro/pagamento-taxa/lote/${idLote}/processos/${idProcesso}/cancelar`,
        { observacao },
      );
      return data;
    } finally {
      setSalvando(false);
    }
  };

  return { salvando, pagarManual, cancelar };
}
